var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Error"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 894",
    d: "M4 12C4 16.4183 7.58172 20 12 20C14.2474 20 16.2783 19.0733 17.7315 17.5812C19.1353 16.1399 20 14.1709 20 12C20 7.58172 16.4183 4 12 4C9.80628 4 7.81879 4.88297 6.37354 6.31291C4.90797 7.76295 4 9.77544 4 12Z",
    stroke: "#EB4848",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 8.28906V11.7475",
    stroke: "#EB4848",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 15.207H12.0106",
    stroke: "#EB4848",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.e9fd415621b848341de33c64a01458a7.svg";
export { ForwardRef as ReactComponent };